// extracted by mini-css-extract-plugin
module.exports = {"article-head":"head_article-head__PNdxu","image-info":"head_image-info__g_gDd","subtitle":"head_subtitle__sO4Xk","title":"head_title__hsT5t","xsmall":"head_xsmall__y4T2T"};